// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fonts import */
body {
  font-family: "Poppins", sans-serif;
  color: #0c0c0c;
  background-color: #ffffff;
  overflow-x: hidden;
}

.layout_padding {
  padding: 90px 0;
}

.layout_padding2 {
  padding: 45px 0;
}

.layout_padding2-top {
  padding-top: 45px;
}

.layout_padding2-bottom {
  padding-bottom: 45px;
}

.layout_padding-top {
  padding-top: 90px;
}

.layout_padding-bottom {
  padding-bottom: 90px;
}

.long_section {
  margin-left: 45px;
  margin-right: 45px;
  padding-left: 15px;
  padding-right: 15px;
}

.heading_container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.heading_container h2 {
  position: relative;
  font-weight: bold;
  text-transform: uppercase;
}

/*header section*/
.hero_area {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
}

.sub_page .hero_area {
  min-height: auto;
}

.header_section {
  background-color: #ffffff;
}

.header_section .container-fluid {
  padding-right: 25px;
  padding-left: 25px;
}

.header_section .nav_container {
  margin: 0 auto;
}

.custom_nav-container .navbar-nav .nav-item .nav-link {
  padding: 3px 15px;
  margin: 10px 15px;
  color: #272727;
  text-align: center;
  text-transform: uppercase;
}

a,
a:hover,
a:focus {
  text-decoration: none;
}

a:hover,
a:focus {
  color: initial;
}

.btn,
.btn:focus {
  outline: none !important;
  box-shadow: none;
}

.custom_nav-container .nav_search-btn {
  width: 35px;
  height: 35px;
  padding: 0;
  border: none;
}

.navbar-brand span {
  font-size: 24px;
  font-weight: 700;
  color: #272727;
  text-transform: uppercase;
}

.custom_nav-container {
  z-index: 99999;
  padding: 5px 0;
}

.custom_nav-container .navbar-toggler {
  outline: none;
}

.custom_nav-container .navbar-toggler {
  padding: 0;
  width: 37px;
  height: 42px;
  transition: all 0.3s;
}

.custom_nav-container .navbar-toggler span {
  display: block;
  width: 32px;
  height: 4px;
  background-color: #000000;
  border-radius: 15px;
  margin: 7px 0;
  transition: all 0.3s;
  position: relative;
  transition: all 0.3s;
}

.custom_nav-container .navbar-toggler span::before, .custom_nav-container .navbar-toggler span::after {
  content: "";
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #000000;
  border-radius: 15px;
  top: -10px;
  transition: all 0.3s;
}

.custom_nav-container .navbar-toggler span::after {
  top: 10px;
}

.custom_nav-container .navbar-toggler[aria-expanded="true"] {
  transform: rotate(360deg);
}

.custom_nav-container .navbar-toggler[aria-expanded="true"] span {
  transform: rotate(45deg);
}

.custom_nav-container .navbar-toggler[aria-expanded="true"] span::before, .custom_nav-container .navbar-toggler[aria-expanded="true"] span::after {
  transform: rotate(90deg);
  top: 0;
}

.quote_btn-container {
  display: flex;
  align-items: center;
}

.quote_btn-container a {
  color: #151515;
  margin-right: 25px;
  text-transform: uppercase;
}

.quote_btn-container a span {
  margin-right: 5px;
}

/*end header section*/
/* slider section */
.slider_section {
  flex: 1 1;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #f9fafa;
}

.slider_section .row {
  align-items: center;
}

.slider_section #customCarousel {
  width: 100%;
  z-index: 3;
}

.slider_section .detail-box {
  color: #000000;
}

.slider_section .detail-box h1 {
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 0;
}

.slider_section .detail-box p {
  margin: 25px 0;
}

.slider_section .detail-box .btn-box {
  display: flex;
  margin: 0 -5px;
}

.slider_section .detail-box .btn-box a {
  margin: 5px;
  text-align: center;
  width: 165px;
}

.slider_section .detail-box .btn-box .btn1 {
  display: inline-block;
  padding: 10px 15px;
  background-color: #f89646;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #f89646;
  transition: all .2s;
}

.slider_section .detail-box .btn-box .btn1:hover {
  background-color: transparent;
  color: #f89646;
}

.slider_section .detail-box .btn-box .btn2 {
  display: inline-block;
  padding: 10px 15px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #6bb7be;
  transition: all .2s;
}

.slider_section .detail-box .btn-box .btn2:hover {
  background-color: transparent;
  color: #6bb7be;
}

.slider_section .img-box img {
  width: 100%;
}

.slider_section .carousel-indicators {
  position: unset;
  margin: 0;
  justify-content: center;
  align-items: center;
  margin-top: 45px;
}

.slider_section .carousel-indicators li {
  background-color: #6bb7be;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  opacity: 1;
}

.slider_section .carousel-indicators li.active {
  width: 17px;
  height: 17px;
  background-color: #f89646;
}

.furniture_section .box {
  margin-top: 45px;
  background-color: #f7fafa;
  padding: 25px;
  border-radius: 5px;
}

.furniture_section .box .img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 275px;
  padding: 25px;
}

.furniture_section .box .img-box img {
  max-width: 100%;
  max-height: 100%;
}

.furniture_section .box .detail-box {
  margin-top: 15px;
}

.furniture_section .box .detail-box h5 {
  text-transform: uppercase;
  font-size: 18px;
}

.furniture_section .box .detail-box .price_box {
  display: flex;
  justify-content: space-between;
}

.furniture_section .box .detail-box .price_box .price_heading {
  margin-bottom: 0;
}

.furniture_section .box .detail-box .price_box .price_heading span {
  color: #6bb7be;
}

.furniture_section .box .detail-box .price_box a {
  color: #6bb7be;
  text-transform: uppercase;
  font-size: 15px;
}

.about_section {
  background-color: #f9fafa;
}

.about_section .row {
  align-items: center;
}

.about_section .img-box img {
  width: 100%;
}

.about_section .detail-box p {
  margin-top: 10px;
  margin-bottom: 35px;
}

.about_section .detail-box a {
  display: inline-block;
  padding: 10px 45px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #6bb7be;
  transition: all .2s;
}

.about_section .detail-box a:hover {
  background-color: transparent;
  color: #6bb7be;
}

.blog_section .heading_container {
  align-items: center;
}

.blog_section .heading_container h2::before {
  left: 50%;
  transform: translateX(-50%);
}

.blog_section .box {
  margin-top: 55px;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}

.blog_section .box .img-box {
  position: relative;
}

.blog_section .box .img-box img {
  width: 100%;
}

.blog_section .box .detail-box {
  padding: 25px;
}

.blog_section .box .detail-box h5 {
  font-weight: bold;
}

.blog_section .box .detail-box p {
  font-size: 15px;
  color: #444;
}

.blog_section .box .detail-box a {
  display: inline-block;
  padding: 10px 30px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #6bb7be;
  transition: all .2s;
}

.blog_section .box .detail-box a:hover {
  background-color: transparent;
  color: #6bb7be;
}

.client_section .heading_container {
  align-items: center;
}

.client_section .box {
  display: flex;
  align-items: center;
  margin: 45px;
  padding: 35px 25px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.client_section .box .img-box {
  border-radius: 100%;
  border: 10px solid #6bb7be;
  margin-right: 25px;
  min-width: 175px;
  max-width: 175px;
  overflow: hidden;
}

.client_section .box .img-box img {
  width: 100%;
}

.client_section .box .detail-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.client_section .box .detail-box .name {
  text-align: center;
}

.client_section .box .detail-box .name img {
  width: 25px;
  margin-bottom: 5px;
}

.client_section .box .detail-box .name h6 {
  color: #6bb7be;
  font-size: 20px;
}

.client_section .carousel_btn-container {
  display: flex;
  justify-content: center;
}

.client_section .carousel-control-prev,
.client_section .carousel-control-next {
  position: unset;
  width: 45px;
  height: 45px;
  border: none;
  opacity: 1;
  background-repeat: no-repeat;
  background-size: 12px;
  background-position: center;
  background-color: #6bb7be;
  background-position: center;
  border-radius: 100%;
  margin: 0 2.5px;
}

.client_section .carousel-control-prev:hover,
.client_section .carousel-control-next:hover {
  background-color: #000000;
}

.client_section .carousel-control-next {
  left: initial;
}

.contact_section {
  position: relative;
  background-color: #f9fafa;
  padding-top: 75px;
  padding-bottom: 75px;
}

.contact_section .heading_container {
  margin-bottom: 25px;
}

.contact_section .heading_container h2 {
  text-transform: uppercase;
}

.contact_section .form_container input {
  width: 100%;
  border: none;
  height: 50px;
  margin-bottom: 25px;
  padding-left: 15px;
  outline: none;
  color: #101010;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
}

.contact_section .form_container input::placeholder {
  color: #333;
}

.contact_section .form_container input.message-box {
  height: 120px;
}

.contact_section .form_container button {
  border: none;
  text-transform: uppercase;
  display: inline-block;
  padding: 12px 55px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0px;
  border: 1px solid #6bb7be;
  transition: all .2s;
}

.contact_section .form_container button:hover {
  background-color: transparent;
  color: #6bb7be;
}

.contact_section .map_container {
  height: 500px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  padding: 0;
}

.contact_section .map_container .map {
  height: 100%;
  flex: 1 1;
}

.contact_section .map_container .map #googleMap {
  height: 100%;
}

.info_section {
  background-color: #191e1f;
  color: #ffffff;
  padding-top: 45px;
  padding-bottom: 45px;
}

.info_section .contact_nav {
  display: flex;
  justify-content: center;
  padding: 25px 0;
  text-align: center;
}

.info_section .contact_nav a {
  flex: 1 1;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
}

.info_section .contact_nav a i {
  font-size: 28px;
}

.info_section .contact_nav a:hover {
  color: #f89646;
}

.info_section .info_top {
  padding: 45px 0;
}

.info_section h4 {
  text-transform: uppercase;
  position: relative;
  margin-bottom: 25px;
}

.info_section .info_links .info_links_menu {
  display: flex;
  flex-wrap: wrap;
}

.info_section .info_links .info_links_menu a {
  color: #ffffff;
  flex-basis: 50%;
}

.info_section .info_links .info_links_menu a:hover, .info_section .info_links .info_links_menu a.active {
  color: #f89646;
}

.info_section .info_post .post_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.info_section .info_post .post_box .img-box {
  min-width: 65px;
  max-width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  flex-basis: calc(33% - 10px);
  padding: 10px;
  margin: 5px;
}

.info_section .info_post .post_box .img-box img {
  max-width: 100%;
  max-height: 100%;
}

.info_section .info_post .post_box p {
  margin: 0;
}

.info_section .info_post .post_box:not(:nth-last-child(1)) {
  margin-bottom: 15px;
}

.info_section .info_form input {
  width: 100%;
  border: none;
  height: 45px;
  margin-bottom: 15px;
  padding-left: 25px;
  background-color: #eaeaea;
  outline: none;
  color: #101010;
}

.info_section .info_form button {
  display: inline-block;
  padding: 10px 45px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0px;
  border: 1px solid #6bb7be;
  transition: all .2s;
}

.info_section .info_form button:hover {
  background-color: transparent;
  color: #6bb7be;
}

.info_section .info_form .social_box {
  width: 100%;
  display: flex;
  margin-top: 25px;
}

.info_section .info_form .social_box a {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 45px;
  height: 45px;
  border: 1px solid #6bb7be;
  color: #6bb7be;
  font-size: 18px;
  margin-right: 10px;
}

.info_section .info_form .social_box a:hover {
  color: #f89646;
  border-color: #f89646;
}

/* footer section*/
.footer_section {
  position: relative;
  text-align: center;
}

.footer_section p {
  color: #000000;
  padding: 25px 0;
  margin: 0;
}

.footer_section p a {
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/css/style.scss","webpack://./src/css/style.css"],"names":[],"mappings":"AAgCA,iBAAA;AACA;EAEA,kCAAK;EA5BH,cAAa;EA8Bb,yBAAc;EACd,kBAAkB;AChCpB;;AAEA;EDkCA,eAAgB;AChChB;;AAEA;EDkCA,eAAiB;AChCjB;;AAEA;EDkCA,iBAAA;AChCA;;AAEA;EDkCA,oBAAA;AChCA;;AAEA;EDkCA,iBAAmB;AChCnB;;AAEA;EDkCA,oBAAsB;AChCtB;;AAEA;EDkCA,iBAAc;EACZ,kBAAiB;EACjB,kBAAkB;EAClB,mBAAkB;AChCpB;;AAEA;EDoCE,aAAA;EAFF,sBAKK;EAGD,uBAAyB;AC/B7B;;ADuCA;EACA,kBAAW;EACT,iBAAiB;EACjB,yBAAkB;ACpCpB;;AAEA,iBDsCC;ACrCD;EDuCA,iBACE;EACE,kBAAgB;EAKpB,aAAe;EAAf,sBAGkB;ACvClB;;AAEA;EACE,gBAAgB;ADiClB;;AC9BA;EACE,yBAAyB;AD0C3B;;ACvCA;ED6CQ,mBAAc;EACd,kBAAkB;AC3C1B;;AAEA;EDqDC,cAAA;AACD;;AClDA;EDqDC,iBAAA;ECnDC,iBAAiB;EDqDlB,cAAM;EACN,kBAAO;EACN,yBAAc;ACnDhB;;ADsDA;;;EAGE,qBAAgB;ACnDlB;;ADsDA;;EAEE,cAAY;ACnDd;;AAEA;;EDsDA,wBACO;EAEH,gBAAgB;ACpDpB;;AAEA;EACE,WAAW;EDuDb,YAAA;EACE,UAAS;EACT,YAAS;ACrDX;;ADwDA;EACE,eAAa;EACd,gBAAA;ECrDC,cAAc;EDuDhB,yBAAsB;ACrDtB;;AAEA;EDuDE,cAAY;EA6Cb,cAAA;ACjGD;;AAEA;EDsDI,aAAW;ACpDf;;AAEA;EDsDI,UAAQ;EACR,WAAU;EACV,YAAU;EAmBX,oBAAA;ACrEH;;AAEA;EDsDM,cAAU;EACV,WAAO;EACP,WAAQ;EACR,yBAAW;EACX,mBA1ME;EA2MF,aAAa;EAEb,oBAAoB;EACrB,kBAAA;ECpDH,oBAAoB;ADwBtB;;ACrBA;EACE,WAAW;EDoBb,kBAAA;EAoCI,OAAA;EAWD,YAAA;EC/DD,WAAW;EDgBb,yBAAsB;EAuChB,mBAAW;EAOZ,UAAA;EA9CL,oBAAsB;ACVtB;;AAEA;EACE,SAAS;AD0DX;;ACvDA;EAEU,yBAAyB;ADqDnC;;AClDA;ED8DG,wBAAA;AC3DH;;AAEA;EAEU,wBAAwB;ED0DlC,MAAA;AAEA;;ACxDA;ED6DE,aAAU;ECvDF,mBAAmB;ADmD7B;;AChDA;EACE,cAAc;ED+ChB,kBAYE;EACE,yBAAW;ACzDf;;AAEA;ED0CA,iBAiBE;ACzDF;;AAEA,qBAAqB;ADsCrB,mBAiBE;ACrDF;ED4DK,SAAA;EAGC,aAAQ;EA3Bd,mBA8BI;EACE,kBAAa;EACb,yBAAc;ACxDpB;;ADwBA;EAqCe,mBAAK;ACvDpB;;ADkBA;EA3OE,WAAS;EACT,UAmR2C;ACtD7C;;AAEA;ED3NE,cAAY;AC6Nd;;AAEA;ED5NE,iBAoPA;EAnPE,yBAAkB;EAClB,gBApBc;ACkPlB;;ADGA;EA3OE,cAAS;AC4OX;;AAEA;EDxOE,aAAY;EAmRP,cAAA;ACtCP;;AAEA;ED3OI,WArBO;EAsBR,kBAAA;EC6OD,YAAY;ADbd;;ACgBA;EACE,qBAAqB;EDjBvB,kBAwDE;EACE,yBAAe;EACf,cAAS;EACT,gBAAe;EACf,yBAAmB;EAgBpB,mBAAA;ACnDH;;AAEA;EDsCM,6BAAW;EACX,cAAY;ACpClB;;AAEA;EACE,qBAAqB;EDjCvB,kBAwDE;EAeM,yBAAW;EACX,cAAY;EACZ,gBAAgB;EACjB,yBAAA;EASP,mBACE;AC3CF;;AAEA;ED8CI,6BAAkB;EA2CnB,cAAA;ACtFH;;AAEA;ED6CM,WAAA;AC3CN;;AAEA;EDkDK,eAAA;EChDH,SAAS;ED8CH,uBAAgB;EAjBxB,mBAqBI;EACE,gBAAgB;AC3CtB;;ADqBA;EAyBQ,yBAAyB;EAEzB,WAAW;EACZ,YAAA;EC3CL,mBAAmB;EDerB,UAAA;ACbA;;AAEA;EACE,WAAW;EDUb,YAAA;EAuCU,yBAAgB;AC9C1B;;ADOA;EAoCY,gBA7WM;EA8WP,yBAAA;ECvCT,aAAa;EDEf,kBACE;ACDF;;AAEA;EDsDA,aAAe;EChDL,uBAAuB;EDqD9B,mBAAA;ECjDD,aAAa;ED4Cf,aAOE;ACjDF;;AAEA;EDwCA,eAaE;EAEI,gBAAgB;ACpDtB;;AAEA;EDmCA,gBAaE;AC9CF;;AAEA;EDpVE,yBAhBa;EAiBb,eAsYqD;AChDvD;;AAEA;EDnVI,aAAA;ECyVM,8BAA8B;ADkDxC;;AC/CA;EACE,gBAAgB;AD8ClB;;AC3CA;EDmDO,cAAA;ACjDP;;AAEA;EDqDI,cAAA;EACA,yBAAoC;EA2BrC,eAAA;AC7EH;;AAEA;EDwDK,yBAAA;ACtDL;;AAEA;ED6BA,mBAyBI;AClDJ;;AAEA;EDuBA,WAAa;ACrBb;;AAEA;EDmBA,gBAYM;EAsBE,mBAAe;AClDvB;;AAEA;EDcA,qBAyBI;EA7aF,kBAAS;EACT,yBA0bqD;EAzbrD,cAAA;EACA,gBAhBa;EAiBb,yBAubwD;EArbxD,mBAAmB;ACyYrB;;ADvYE;EACE,6BAA6B;EAC7B,cArBc;AC+ZlB;;ADiDA;EC5CU,mBAAmB;AD4C7B;;ACzCA;EDiDI,SAAQ;EAER,2BAAoC;AC/CxC;;ADqCA;EAaM,gBAAe;EACf,yBA9dK;EAgeL,0CAAgB;AC9CtB;;AAEA;EACE,kBAAkB;AD2BpB;;ACxBA;EACE,WAAW;ADuBb;;ACpBA;EDgDM,aAAa;AC9CnB;;ADkBA;EA+BQ,iBAAY;AC7CpB;;ADcA;EAkCU,eAAW;EACX,WAAA;AC5CV;;ADSA;EAuCU,qBAvfQ;EAwfR,kBAAe;EAChB,yBAAA;EC5CP,cAAc;EDGhB,gBA8CE;EACE,yBAAa;EAEd,mBAAA;AC/CH;;ADFA;EAqDI,6BAAe;EACf,cAAW;AC/Cf;;AAEA;EDmDI,mBAA2B;AC/C/B;;AAEA;EAGE,aAAa;EDiDT,mBAphBS;EAqhBV,YAAA;EC7CH,kBAAkB;EDiDV,0CAAO;AC9CjB;;ADqDA;EACE,mBAAkB;EAClB,0BA/hBc;EAgiBd,kBAAiB;EACjB,gBAAgB;EAuDjB,gBAAA;ECxGC,gBAAgB;AD6ClB;;AC1CA;EACE,WAAW;ADyCb;;ACtCA;EDwDM,aAAW;EAIX,sBAAkB;EAGlB,uBAAmC;ACpDzC;;AD2BA;EA4BQ,kBAAW;ACnDnB;;ADuBA;EAgCQ,WAAQ;EACT,kBAAA;ACnDP;;AAEA;EDsDM,cAAc;EA1jBlB,eAAS;ACugBX;;AAEA;EDngBE,aAAY;EAEZ,uBAgjBE;ACxCJ;;AAEA;;EDEA,eA2CE;EACE,WAAQ;EACR,YAAU;EACV,YAAS;EACT,UAAA;EACA,4BAAU;EAUX,qBAAA;ECnDD,2BAA2B;EDP7B,yBA2CE;EAQI,2BAAY;EACZ,mBAAO;EAKR,eAAA;AC7CL;;AAEA;;EAEE,yBAAyB;ADkD3B;;AC/CA;EDkDE,aAAa;AChDf;;AAEA;ED2CA,kBAME;EACE,yBAAa;EACb,iBAAiB;EACjB,oBAAe;AC/CnB;;AAEA;EDoCA,mBAME;ACxCF;;AAEA;EDgDM,yBAAsB;AC9C5B;;AAEA;EACE,WAAW;ED2Bb,YAME;EAeM,YAAW;EACZ,mBAAA;EC7CL,kBAAkB;EDuBpB,aAME;EAmBM,cAznBU;EC6kBR,yCAAyC;ADmBnD;;ACJA;EDIA,WAAa;ACFb;;AAEA;EACE,aAAa;ADDf;;ACIA;EACE,YAAY;EDLd,yBA4DI;EACE,qBAAa;EACb,kBAAe;EACf,yBAAmB;EA2BpB,cAAA;EC/EH,kBAAkB;EDXpB,yBA4DI;EAOI,mBAAe;ACpDvB;;AAEA;EDsDQ,6BAAmB;EACnB,cAAA;ACpDR;;AAEA;ED2DO,aAAA;ECzDL,gBAAgB;EDuDR,aAAY;EA/EtB,oBA4DI;EAwBI,UAAS;ACpDjB;;ADhCA;EAwFQ,YAAA;EAxFR,SA6FE;ACtDF;;AAEA;EDyDM,YAAA;ACvDN;;AAEA;EDyDM,yBAAc;EACf,cAAA;ECvDH,iBAAiB;EDhDnB,oBA6FE;AC3CF;;AAEA;EDroBE,aAAY;EC2oBJ,uBAAuB;EDxoB/B,eA2qBA;EA1qBE,kBAAkB;AC0oBtB;;AAEA;EDiDa,SAAM;EACb,SAAA;EAjHN,aA6FE;EA0BM,sBAAkB;EAGV,mBA3tBE;EA4tBV,cA5tBU;ACgrBlB;;AAEA;EACE,eAAe;ADlFjB;;ACqFA;ED6CS,cAAA;AC3CT;;ADuDA;EACE,eAAU;ACpDZ;;AAEA;EDiDA,yBAII;EACA,kBArvBW;EAsvBX,mBAAe;ACnDnB;;AAEA;EDsDK,aAAA;ECjDC,eAAe;AACrB;;AAEA;EACE,cAAc;EAEV,eAAe;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAGE,aAAa;EAET,eAAe;EAGX,mBAAmB;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EAGZ,aAAa;EAGL,uBAAuB;EAGvB,mBAAmB;EAC3B,yBAAyB;EAErB,4BAA4B;EAChC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EAEzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;EAGX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGL,uBAAuB;EAGvB,mBAAmB;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB","sourcesContent":["$white: #ffffff;\r\n$black: #000000;\r\n$primary1: #6bb7be;\r\n$primary2: #f89646;\r\n$bgColor:#f9fafa;\r\n\r\n/* fonts import */\r\n@font-face {\r\n  font-family: \"octin\";\r\n  src: local(\"octin_sports_rg\"), url('../fonts/octin_sports_rg.ttf') format(\"truetype\");\r\n}\r\n\r\n@mixin main-font {\r\n  font-family: \"Poppins\", sans-serif;\r\n}\r\n\r\n@mixin hero_btn($col1, $col2, $pad1, $pad2, $bRadius) {\r\n  display: inline-block;\r\n  padding: $pad1 $pad2;\r\n  background-color: $col1;\r\n  color: $col2;\r\n  border-radius: $bRadius;\r\n  border: 1px solid $col1;\r\n  transition: all .2s;\r\n\r\n  &:hover {\r\n    background-color: transparent;\r\n    color: $col1;\r\n  }\r\n}\r\n\r\n@mixin upperBold {\r\n  text-transform: uppercase;\r\n  font-weight: bold;\r\n}\r\n\r\nbody {\r\n  font-family: \"Poppins\";\r\n  color: #0c0c0c;\r\n  background-color: #ffffff;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.layout_padding {\r\n  padding: 90px 0;\r\n}\r\n\r\n.layout_padding2 {\r\n  padding: 45px 0;\r\n}\r\n\r\n.layout_padding2-top {\r\n  padding-top: 45px;\r\n}\r\n\r\n.layout_padding2-bottom {\r\n  padding-bottom: 45px;\r\n}\r\n\r\n.layout_padding-top {\r\n  padding-top: 90px;\r\n}\r\n\r\n.layout_padding-bottom {\r\n  padding-bottom: 90px;\r\n}\r\n\r\n.long_section {\r\n  margin-left: 45px;\r\n  margin-right: 45px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.heading_container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n\r\n  h1,h2 {\r\n    position: relative;\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n\r\n  }\r\n}\r\n\r\nh1,\r\nh2 {}\r\n\r\n/*header section*/\r\n.hero_area {\r\n  min-height: 100vh;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n.sub_page {\r\n  .hero_area {\r\n    min-height: auto;\r\n\r\n  }\r\n}\r\n\r\n.header_section {\r\n  background-color: $white;\r\n\r\n  .container-fluid {\r\n    padding-right: 25px;\r\n    padding-left: 25px;\r\n  }\r\n\r\n  .nav_container {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.custom_nav-container {\r\n  .navbar-nav {\r\n    .nav-item {\r\n      .nav-link {\r\n        padding: 3px 15px;\r\n        margin: 10px 15px;\r\n        color: #272727;\r\n        text-align: center;\r\n        text-transform: uppercase;\r\n      }\r\n\r\n      &.active,\r\n      &:hover {\r\n        .nav-link {}\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\na,\r\na:hover,\r\na:focus {\r\n  text-decoration: none;\r\n}\r\n\r\na:hover,\r\na:focus {\r\n  color: initial;\r\n}\r\n\r\n.btn,\r\n.btn:focus {\r\n  outline: none !important;\r\n  box-shadow: none;\r\n}\r\n\r\n.custom_nav-container .nav_search-btn {\r\n  width: 35px;\r\n  height: 35px;\r\n  padding: 0;\r\n  border: none;\r\n}\r\n\r\n.navbar-brand {\r\n  span {\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: #272727;\r\n    text-transform: uppercase;\r\n  }\r\n}\r\n\r\n.custom_nav-container {\r\n  z-index: 99999;\r\n  padding: 5px 0;\r\n}\r\n\r\n.custom_nav-container .navbar-toggler {\r\n  outline: none;\r\n}\r\n\r\n.custom_nav-container .navbar-toggler {\r\n  padding: 0;\r\n  width: 37px;\r\n  height: 42px;\r\n  transition: all 0.3s;\r\n\r\n  span {\r\n    display: block;\r\n    width: 32px;\r\n    height: 4px;\r\n    background-color: #000;\r\n    border-radius: 15px;\r\n    margin: 7px 0;\r\n    transition: all 0.3s;\r\n    position: relative;\r\n    transition: all 0.3s;\r\n\r\n    &::before,\r\n    &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      left: 0;\r\n      height: 100%;\r\n      width: 100%;\r\n      background-color: $black;\r\n      border-radius: 15px;\r\n      top: -10px;\r\n      transition: all 0.3s;\r\n    }\r\n\r\n    &::after {\r\n      top: 10px;\r\n    }\r\n  }\r\n\r\n  &[aria-expanded=\"true\"] {\r\n    transform: rotate(360deg); \r\n\r\n    span {\r\n      transform: rotate(45deg); \r\n\r\n      &::before,\r\n      &::after {\r\n        transform: rotate(90deg);\r\n        top: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.quote_btn-container {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  a {\r\n    color: #151515;\r\n    margin-right: 25px;\r\n    text-transform: uppercase;\r\n\r\n    span {\r\n      margin-right: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n/*end header section*/\r\n\r\n/* slider section */\r\n.slider_section {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n  background-color: $bgColor;\r\n\r\n\r\n  .row {\r\n    align-items: center;\r\n  }\r\n\r\n  #customCarousel {\r\n    width: 100%;\r\n    z-index: 3;\r\n  }\r\n\r\n  .detail-box {\r\n    color: $black;\r\n\r\n    h1 {\r\n      font-weight: bold;\r\n      text-transform: uppercase;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    p {\r\n      margin: 25px 0;\r\n    }\r\n\r\n    .btn-box {\r\n      display: flex;\r\n      margin: 0 -5px;\r\n\r\n      a {\r\n        margin: 5px;\r\n        text-align: center;\r\n        width: 165px;\r\n      }\r\n\r\n      .btn1 {\r\n        @include hero_btn($primary2, $white, 10px, 15px, 0);\r\n      }\r\n\r\n      .btn2 {\r\n        @include hero_btn($primary1, $white, 10px, 15px, 0);\r\n      }\r\n    }\r\n  }\r\n\r\n  .img-box {\r\n    img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .carousel-indicators {\r\n    position: unset;\r\n    margin: 0;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 45px;\r\n\r\n    li {\r\n      background-color: $primary1;\r\n      width: 12px;\r\n      height: 12px;\r\n      border-radius: 100%;\r\n      opacity: 1;\r\n\r\n      &.active {\r\n        width: 17px;\r\n        height: 17px;\r\n        background-color: $primary2;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end slider section\r\n\r\n// furniture section\r\n\r\n.furniture_section {\r\n  .box {\r\n    margin-top: 45px;\r\n    // box-shadow: 0 0 5px 0 rgba($color: #000000, $alpha: .25);\r\n    background-color: #f7fafa;\r\n    padding: 25px;\r\n    border-radius: 5px;\r\n\r\n    .img-box {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      height: 275px;\r\n      padding: 25px;\r\n\r\n      img {\r\n        max-width: 100%;\r\n        max-height: 100%;\r\n      }\r\n    }\r\n\r\n    .detail-box {\r\n      margin-top: 15px;\r\n\r\n      h5 {\r\n        text-transform: uppercase;\r\n\r\n        font-size: 18px;\r\n      }\r\n\r\n      .price_box {\r\n        display: flex;\r\n        justify-content: space-between;\r\n\r\n        .price_heading {\r\n          span {\r\n            color: $primary1;\r\n          }\r\n\r\n          margin-bottom: 0;\r\n        }\r\n\r\n        a {\r\n          color: $primary1;\r\n          text-transform: uppercase;\r\n          font-size: 15px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end furniture section\r\n\r\n// about section\r\n\r\n.about_section {\r\n  background-color: $bgColor;\r\n\r\n  .row {\r\n    align-items: center;\r\n  }\r\n\r\n  .img-box {\r\n    img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .detail-box {\r\n    p {\r\n      margin-top: 10px;\r\n      margin-bottom: 35px;\r\n    }\r\n\r\n    a {\r\n      @include hero_btn($primary1, $white, 10px, 45px, 0);\r\n    }\r\n  }\r\n}\r\n\r\n// end about section\r\n\r\n\r\n\r\n// blog section\r\n.blog_section {\r\n  .heading_container {\r\n    align-items: center;\r\n\r\n    h2 {\r\n      &::before {\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n      }\r\n    }\r\n  }\r\n\r\n  .box {\r\n    margin-top: 55px;\r\n    background-color: $white;\r\n    box-shadow: 0 0 10px 0 rgba($color: #000000, $alpha: 0.15);\r\n\r\n    .img-box {\r\n      position: relative;\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .detail-box {\r\n      padding: 25px;\r\n\r\n      h5 {\r\n        font-weight: bold;\r\n\r\n      }\r\n\r\n      p {\r\n        font-size: 15px;\r\n        color: #444;\r\n      }\r\n\r\n      a {\r\n        @include hero_btn($primary1, $white, 10px, 30px, 0);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end blog section\r\n\r\n// client section\r\n\r\n.client_section {\r\n  .heading_container {\r\n    align-items: center;\r\n  }\r\n\r\n  .box {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 45px;\r\n    padding: 35px 25px;\r\n    box-shadow: 0 0 15px 0 rgba($color: #000000, $alpha: 0.15);\r\n\r\n    .img-box {\r\n      border-radius: 100%;\r\n      border: 10px solid $primary1;\r\n      margin-right: 25px;\r\n      min-width: 175px;\r\n      max-width: 175px;\r\n      overflow: hidden;\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .detail-box {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n\r\n      .name {\r\n        text-align: center;\r\n\r\n        img {\r\n          width: 25px;\r\n          margin-bottom: 5px;\r\n        }\r\n\r\n        h6 {\r\n          color: $primary1;\r\n          font-size: 20px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .carousel_btn-container {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .carousel-control-prev,\r\n  .carousel-control-next {\r\n    position: unset;\r\n    width: 45px;\r\n    height: 45px;\r\n    border: none;\r\n    opacity: 1;\r\n    background-repeat: no-repeat;\r\n    background-size: 12px;\r\n    background-position: center;\r\n    background-color: $primary1;\r\n    background-position: center;\r\n    border-radius: 100%;\r\n    margin: 0 2.5px;\r\n\r\n    &:hover {\r\n      background-color: $black;\r\n    }\r\n  }\r\n\r\n  .carousel-control-next {\r\n    left: initial;\r\n  }\r\n}\r\n\r\n// end client section\r\n\r\n// contact section\r\n.contact_section {\r\n  position: relative;\r\n  background-color: $bgColor;\r\n  padding-top: 75px;\r\n  padding-bottom: 75px;\r\n\r\n  .heading_container {\r\n    margin-bottom: 25px;\r\n\r\n    h2 {\r\n      text-transform: uppercase;\r\n    }\r\n  }\r\n\r\n\r\n  .form_container {\r\n\r\n    input {\r\n      width: 100%;\r\n      border: none;\r\n      height: 50px;\r\n      margin-bottom: 25px;\r\n      padding-left: 15px;\r\n      outline: none;\r\n      color: #101010;\r\n      box-shadow: 0 0 5px 0 rgba($color: #000000, $alpha: .05);\r\n\r\n      &::placeholder {\r\n        color: #333;\r\n      }\r\n\r\n      &.message-box {\r\n        height: 120px;\r\n      }\r\n    }\r\n\r\n    button {\r\n      border: none;\r\n      text-transform: uppercase;\r\n      @include hero_btn($primary1, $white, 12px, 55px, 0px);\r\n    }\r\n  }\r\n\r\n  .map_container {\r\n    height: 500px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: stretch;\r\n    padding: 0;\r\n\r\n    .map {\r\n      height: 100%;\r\n      flex: 1;\r\n\r\n      #googleMap {\r\n        height: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end contact section\r\n\r\n\r\n\r\n// info section\r\n.info_section {\r\n  background-color: #191e1f;\r\n  color: $white;\r\n  padding-top: 45px;\r\n  padding-bottom: 45px;\r\n\r\n  .contact_nav {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 25px 0;\r\n    text-align: center;\r\n\r\n    a {\r\n      flex: 1;\r\n      margin: 0;\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      color: $white;\r\n\r\n      i {\r\n        font-size: 28px;\r\n      }\r\n\r\n      &:hover {\r\n        color: $primary2;\r\n      }\r\n    }\r\n  }\r\n\r\n  .info_top {\r\n    padding: 45px 0;\r\n  }\r\n\r\n\r\n  h4 {\r\n    text-transform: uppercase;\r\n    position: relative;\r\n    margin-bottom: 25px;\r\n\r\n  }\r\n\r\n  .info_links {\r\n    .info_links_menu {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n\r\n      a {\r\n        color: $white;\r\n        flex-basis: 50%;\r\n\r\n        &:hover,\r\n        &.active {\r\n          color: $primary2;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .info_post {\r\n    .post_box {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      align-items: center;\r\n\r\n      .img-box {\r\n        min-width: 65px;\r\n        max-width: 65px;\r\n        height: 65px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        background-color: $white;\r\n        flex-basis: calc(33% - 10px);\r\n        padding: 10px;\r\n        margin: 5px;\r\n\r\n        img {\r\n          max-width: 100%;\r\n          max-height: 100%;\r\n        }\r\n      }\r\n\r\n      p {\r\n        margin: 0;\r\n      }\r\n\r\n      &:not(:nth-last-child(1)) {\r\n        margin-bottom: 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .info_form {\r\n    input {\r\n      width: 100%;\r\n      border: none;\r\n      height: 45px;\r\n      margin-bottom: 15px;\r\n      padding-left: 25px;\r\n      background-color: #eaeaea;\r\n      outline: none;\r\n      color: #101010;\r\n    }\r\n\r\n    button {\r\n      @include hero_btn($primary1, $white, 10px, 45px, 0px);\r\n\r\n    }\r\n\r\n    .social_box {\r\n      width: 100%;\r\n      display: flex;\r\n      margin-top: 25px;\r\n\r\n      a {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        border-radius: 5px;\r\n        width: 45px;\r\n        height: 45px;\r\n        border: 1px solid $primary1;\r\n        color: $primary1;\r\n        font-size: 18px;\r\n        margin-right: 10px;\r\n\r\n        &:hover {\r\n          color: $primary2;\r\n          border-color: $primary2;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n}\r\n\r\n// end info section\r\n\r\n/* footer section*/\r\n\r\n.footer_section {\r\n  position: relative;\r\n  text-align: center;\r\n\r\n  p {\r\n    color: $black;\r\n    padding: 25px 0;\r\n    margin: 0;\r\n\r\n    a {\r\n      color: inherit;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// end footer section","/* fonts import */\nbody {\n  font-family: \"Poppins\", sans-serif;\n  color: #0c0c0c;\n  background-color: #ffffff;\n  overflow-x: hidden;\n}\n\n.layout_padding {\n  padding: 90px 0;\n}\n\n.layout_padding2 {\n  padding: 45px 0;\n}\n\n.layout_padding2-top {\n  padding-top: 45px;\n}\n\n.layout_padding2-bottom {\n  padding-bottom: 45px;\n}\n\n.layout_padding-top {\n  padding-top: 90px;\n}\n\n.layout_padding-bottom {\n  padding-bottom: 90px;\n}\n\n.long_section {\n  margin-left: 45px;\n  margin-right: 45px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.heading_container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.heading_container h2 {\n  position: relative;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n/*header section*/\n.hero_area {\n  min-height: 100vh;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.sub_page .hero_area {\n  min-height: auto;\n}\n\n.header_section {\n  background-color: #ffffff;\n}\n\n.header_section .container-fluid {\n  padding-right: 25px;\n  padding-left: 25px;\n}\n\n.header_section .nav_container {\n  margin: 0 auto;\n}\n\n.custom_nav-container .navbar-nav .nav-item .nav-link {\n  padding: 3px 15px;\n  margin: 10px 15px;\n  color: #272727;\n  text-align: center;\n  text-transform: uppercase;\n}\n\na,\na:hover,\na:focus {\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  color: initial;\n}\n\n.btn,\n.btn:focus {\n  outline: none !important;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.custom_nav-container .nav_search-btn {\n  width: 35px;\n  height: 35px;\n  padding: 0;\n  border: none;\n}\n\n.navbar-brand span {\n  font-size: 24px;\n  font-weight: 700;\n  color: #272727;\n  text-transform: uppercase;\n}\n\n.custom_nav-container {\n  z-index: 99999;\n  padding: 5px 0;\n}\n\n.custom_nav-container .navbar-toggler {\n  outline: none;\n}\n\n.custom_nav-container .navbar-toggler {\n  padding: 0;\n  width: 37px;\n  height: 42px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.custom_nav-container .navbar-toggler span {\n  display: block;\n  width: 32px;\n  height: 4px;\n  background-color: #000000;\n  border-radius: 15px;\n  margin: 7px 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  position: relative;\n  transition: all 0.3s;\n}\n\n.custom_nav-container .navbar-toggler span::before, .custom_nav-container .navbar-toggler span::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background-color: #000000;\n  border-radius: 15px;\n  top: -10px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.custom_nav-container .navbar-toggler span::after {\n  top: 10px;\n}\n\n.custom_nav-container .navbar-toggler[aria-expanded=\"true\"] {\n  -webkit-transform: rotate(360deg);\n          transform: rotate(360deg);\n}\n\n.custom_nav-container .navbar-toggler[aria-expanded=\"true\"] span {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n\n.custom_nav-container .navbar-toggler[aria-expanded=\"true\"] span::before, .custom_nav-container .navbar-toggler[aria-expanded=\"true\"] span::after {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  top: 0;\n}\n\n.quote_btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.quote_btn-container a {\n  color: #151515;\n  margin-right: 25px;\n  text-transform: uppercase;\n}\n\n.quote_btn-container a span {\n  margin-right: 5px;\n}\n\n/*end header section*/\n/* slider section */\n.slider_section {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n  background-color: #f9fafa;\n}\n\n.slider_section .row {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.slider_section #customCarousel {\n  width: 100%;\n  z-index: 3;\n}\n\n.slider_section .detail-box {\n  color: #000000;\n}\n\n.slider_section .detail-box h1 {\n  font-weight: bold;\n  text-transform: uppercase;\n  margin-bottom: 0;\n}\n\n.slider_section .detail-box p {\n  margin: 25px 0;\n}\n\n.slider_section .detail-box .btn-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 -5px;\n}\n\n.slider_section .detail-box .btn-box a {\n  margin: 5px;\n  text-align: center;\n  width: 165px;\n}\n\n.slider_section .detail-box .btn-box .btn1 {\n  display: inline-block;\n  padding: 10px 15px;\n  background-color: #f89646;\n  color: #ffffff;\n  border-radius: 0;\n  border: 1px solid #f89646;\n  -webkit-transition: all .2s;\n  transition: all .2s;\n}\n\n.slider_section .detail-box .btn-box .btn1:hover {\n  background-color: transparent;\n  color: #f89646;\n}\n\n.slider_section .detail-box .btn-box .btn2 {\n  display: inline-block;\n  padding: 10px 15px;\n  background-color: #6bb7be;\n  color: #ffffff;\n  border-radius: 0;\n  border: 1px solid #6bb7be;\n  -webkit-transition: all .2s;\n  transition: all .2s;\n}\n\n.slider_section .detail-box .btn-box .btn2:hover {\n  background-color: transparent;\n  color: #6bb7be;\n}\n\n.slider_section .img-box img {\n  width: 100%;\n}\n\n.slider_section .carousel-indicators {\n  position: unset;\n  margin: 0;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 45px;\n}\n\n.slider_section .carousel-indicators li {\n  background-color: #6bb7be;\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n  opacity: 1;\n}\n\n.slider_section .carousel-indicators li.active {\n  width: 17px;\n  height: 17px;\n  background-color: #f89646;\n}\n\n.furniture_section .box {\n  margin-top: 45px;\n  background-color: #f7fafa;\n  padding: 25px;\n  border-radius: 5px;\n}\n\n.furniture_section .box .img-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 275px;\n  padding: 25px;\n}\n\n.furniture_section .box .img-box img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.furniture_section .box .detail-box {\n  margin-top: 15px;\n}\n\n.furniture_section .box .detail-box h5 {\n  text-transform: uppercase;\n  font-size: 18px;\n}\n\n.furniture_section .box .detail-box .price_box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.furniture_section .box .detail-box .price_box .price_heading {\n  margin-bottom: 0;\n}\n\n.furniture_section .box .detail-box .price_box .price_heading span {\n  color: #6bb7be;\n}\n\n.furniture_section .box .detail-box .price_box a {\n  color: #6bb7be;\n  text-transform: uppercase;\n  font-size: 15px;\n}\n\n.about_section {\n  background-color: #f9fafa;\n}\n\n.about_section .row {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.about_section .img-box img {\n  width: 100%;\n}\n\n.about_section .detail-box p {\n  margin-top: 10px;\n  margin-bottom: 35px;\n}\n\n.about_section .detail-box a {\n  display: inline-block;\n  padding: 10px 45px;\n  background-color: #6bb7be;\n  color: #ffffff;\n  border-radius: 0;\n  border: 1px solid #6bb7be;\n  -webkit-transition: all .2s;\n  transition: all .2s;\n}\n\n.about_section .detail-box a:hover {\n  background-color: transparent;\n  color: #6bb7be;\n}\n\n.blog_section .heading_container {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.blog_section .heading_container h2::before {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n\n.blog_section .box {\n  margin-top: 55px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n}\n\n.blog_section .box .img-box {\n  position: relative;\n}\n\n.blog_section .box .img-box img {\n  width: 100%;\n}\n\n.blog_section .box .detail-box {\n  padding: 25px;\n}\n\n.blog_section .box .detail-box h5 {\n  font-weight: bold;\n}\n\n.blog_section .box .detail-box p {\n  font-size: 15px;\n  color: #444;\n}\n\n.blog_section .box .detail-box a {\n  display: inline-block;\n  padding: 10px 30px;\n  background-color: #6bb7be;\n  color: #ffffff;\n  border-radius: 0;\n  border: 1px solid #6bb7be;\n  -webkit-transition: all .2s;\n  transition: all .2s;\n}\n\n.blog_section .box .detail-box a:hover {\n  background-color: transparent;\n  color: #6bb7be;\n}\n\n.client_section .heading_container {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.client_section .box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 45px;\n  padding: 35px 25px;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n\n.client_section .box .img-box {\n  border-radius: 100%;\n  border: 10px solid #6bb7be;\n  margin-right: 25px;\n  min-width: 175px;\n  max-width: 175px;\n  overflow: hidden;\n}\n\n.client_section .box .img-box img {\n  width: 100%;\n}\n\n.client_section .box .detail-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.client_section .box .detail-box .name {\n  text-align: center;\n}\n\n.client_section .box .detail-box .name img {\n  width: 25px;\n  margin-bottom: 5px;\n}\n\n.client_section .box .detail-box .name h6 {\n  color: #6bb7be;\n  font-size: 20px;\n}\n\n.client_section .carousel_btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.client_section .carousel-control-prev,\n.client_section .carousel-control-next {\n  position: unset;\n  width: 45px;\n  height: 45px;\n  border: none;\n  opacity: 1;\n  background-repeat: no-repeat;\n  background-size: 12px;\n  background-position: center;\n  background-color: #6bb7be;\n  background-position: center;\n  border-radius: 100%;\n  margin: 0 2.5px;\n}\n\n.client_section .carousel-control-prev:hover,\n.client_section .carousel-control-next:hover {\n  background-color: #000000;\n}\n\n.client_section .carousel-control-next {\n  left: initial;\n}\n\n.contact_section {\n  position: relative;\n  background-color: #f9fafa;\n  padding-top: 75px;\n  padding-bottom: 75px;\n}\n\n.contact_section .heading_container {\n  margin-bottom: 25px;\n}\n\n.contact_section .heading_container h2 {\n  text-transform: uppercase;\n}\n\n.contact_section .form_container input {\n  width: 100%;\n  border: none;\n  height: 50px;\n  margin-bottom: 25px;\n  padding-left: 15px;\n  outline: none;\n  color: #101010;\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);\n}\n\n.contact_section .form_container input::-webkit-input-placeholder {\n  color: #333;\n}\n\n.contact_section .form_container input:-ms-input-placeholder {\n  color: #333;\n}\n\n.contact_section .form_container input::-ms-input-placeholder {\n  color: #333;\n}\n\n.contact_section .form_container input::placeholder {\n  color: #333;\n}\n\n.contact_section .form_container input.message-box {\n  height: 120px;\n}\n\n.contact_section .form_container button {\n  border: none;\n  text-transform: uppercase;\n  display: inline-block;\n  padding: 12px 55px;\n  background-color: #6bb7be;\n  color: #ffffff;\n  border-radius: 0px;\n  border: 1px solid #6bb7be;\n  -webkit-transition: all .2s;\n  transition: all .2s;\n}\n\n.contact_section .form_container button:hover {\n  background-color: transparent;\n  color: #6bb7be;\n}\n\n.contact_section .map_container {\n  height: 500px;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  padding: 0;\n}\n\n.contact_section .map_container .map {\n  height: 100%;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\n.contact_section .map_container .map #googleMap {\n  height: 100%;\n}\n\n.info_section {\n  background-color: #191e1f;\n  color: #ffffff;\n  padding-top: 45px;\n  padding-bottom: 45px;\n}\n\n.info_section .contact_nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 25px 0;\n  text-align: center;\n}\n\n.info_section .contact_nav a {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  margin: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #ffffff;\n}\n\n.info_section .contact_nav a i {\n  font-size: 28px;\n}\n\n.info_section .contact_nav a:hover {\n  color: #f89646;\n}\n\n.info_section .info_top {\n  padding: 45px 0;\n}\n\n.info_section h4 {\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 25px;\n}\n\n.info_section .info_links .info_links_menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.info_section .info_links .info_links_menu a {\n  color: #ffffff;\n  -ms-flex-preferred-size: 50%;\n      flex-basis: 50%;\n}\n\n.info_section .info_links .info_links_menu a:hover, .info_section .info_links .info_links_menu a.active {\n  color: #f89646;\n}\n\n.info_section .info_post .post_box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.info_section .info_post .post_box .img-box {\n  min-width: 65px;\n  max-width: 65px;\n  height: 65px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #ffffff;\n  -ms-flex-preferred-size: calc(33% - 10px);\n      flex-basis: calc(33% - 10px);\n  padding: 10px;\n  margin: 5px;\n}\n\n.info_section .info_post .post_box .img-box img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.info_section .info_post .post_box p {\n  margin: 0;\n}\n\n.info_section .info_post .post_box:not(:nth-last-child(1)) {\n  margin-bottom: 15px;\n}\n\n.info_section .info_form input {\n  width: 100%;\n  border: none;\n  height: 45px;\n  margin-bottom: 15px;\n  padding-left: 25px;\n  background-color: #eaeaea;\n  outline: none;\n  color: #101010;\n}\n\n.info_section .info_form button {\n  display: inline-block;\n  padding: 10px 45px;\n  background-color: #6bb7be;\n  color: #ffffff;\n  border-radius: 0px;\n  border: 1px solid #6bb7be;\n  -webkit-transition: all .2s;\n  transition: all .2s;\n}\n\n.info_section .info_form button:hover {\n  background-color: transparent;\n  color: #6bb7be;\n}\n\n.info_section .info_form .social_box {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 25px;\n}\n\n.info_section .info_form .social_box a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-radius: 5px;\n  width: 45px;\n  height: 45px;\n  border: 1px solid #6bb7be;\n  color: #6bb7be;\n  font-size: 18px;\n  margin-right: 10px;\n}\n\n.info_section .info_form .social_box a:hover {\n  color: #f89646;\n  border-color: #f89646;\n}\n\n/* footer section*/\n.footer_section {\n  position: relative;\n  text-align: center;\n}\n\n.footer_section p {\n  color: #000000;\n  padding: 25px 0;\n  margin: 0;\n}\n\n.footer_section p a {\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
